







































import { Vue, Component, Prop } from 'vue-property-decorator';
import type { ColumnToEdit } from '@/pantallas/OrdenesServicio/types/orderServicioTypes';
import { AxiosVue } from '@/AxiosVue';
import { ServicioProxy } from '@/config/enums';
import { Snotify } from '@/snotify/Snotify';

@Component({
  components: {}
})
export default class EditOrderServicioColumn extends Vue {
  @Prop({ default: "" }) columnValue!: string;
  @Prop({ default: "patente" }) columnToEdit!: ColumnToEdit;
  @Prop({ required: true }) patente: string;

  readonly $snotify: Snotify;
  editTimer: NodeJS.Timeout;
  isLoading = false;
  localValue = this.columnValue;
  finalColumnValue = this.columnValue;
  isOrderServiceColumnReadonly: {
    [key in ColumnToEdit]: boolean;
  } = {
      patente: false,
      marca: false,
      modelo: false,
      anio: false,
    }

  axios: AxiosVue = new AxiosVue(ServicioProxy.Metabase);

  enableEdit() {
    this.$set(this.isOrderServiceColumnReadonly, this.columnToEdit, true);
  }

  confirmEdit() {
    if (this.isLoading) return;
    const value = this.sanitizeValue(this.localValue);

    if (!this.isColumnValid(value)) {
      this.resetValue();
      return;
    }
    this.updateColumn(value);
  }

  columnValidations = {
    patente: (value = "") => value.length > 0,
    marca: (value = "") => value.length > 0,
    modelo: (value = "") => value.length > 0,
    anio: (value = "") => !isNaN(Number(value)) && value.length > 0,
  };

  getErrorMessage(column: ColumnToEdit) {
    const columnName = {
      patente: "Patente",
      marca: "Marca",
      modelo: "Modelo",
      anio: "Año",
    }

    if (column === "anio") {
        return `El campo ${columnName[column]} no puede estar vacío y debe ser un número`;
    }
    return `El campo ${columnName[column]} no puede estar vacío`;
  }

  isColumnValid(value = ""): boolean {
    const validate = this.columnValidations[this.columnToEdit];
    if (validate && !validate(value)) {
      const messageError = this.getErrorMessage(this.columnToEdit);
      this.$snotify.error(messageError);
      return false;
    }
    return true;
  }

  resetValue() {
    this.localValue = this.finalColumnValue;
    this.$set(this.isOrderServiceColumnReadonly, this.columnToEdit, false);
  }

  sanitizeValue(value = "") {
    return value.trim().replace(/\s+/g, ' ');
  }

  async updateColumn(value: string) {
    this.isLoading = true;
    try {
      const { data } = await this.axios.http.post(`Metabase/PostgenericA/CuadraturaServicios/update_orden_servicio_column`, {
        column_to_edit: this.columnToEdit,
        column_value: value,
        serie: this.patente,
      });

      if (data.CODIGO_RESPUESTA.toString() !== "1") {
        this.$snotify.error(data.MENSAJE_RESPUESTA);
        this.resetValue();
        return;
      }
      this.finalColumnValue = value;
      this.$snotify.success(data.MENSAJE_RESPUESTA);
    } catch (error) {
      console.error('Error al actualizar la orden de servicio: ' + error);
      this.$snotify.error("Error al actualizar la orden de servicio");
      this.resetValue();
    } finally {
      this.isLoading = false;
      this.$set(this.isOrderServiceColumnReadonly, this.columnToEdit, false);
    }
  }
}
